import { Color, Object3D } from "three";
import { LineGeometry } from "three/examples/jsm/lines/LineGeometry.js";
import { IVector3 } from "../../r3f-components/component-data-structure";

export const LOCKED_COLOR = new Color(0xdbdee3);
export const DEFAULT_X_AXIS_COLOR_ACTIVE = new Color(0xff6c93);
export const DEFAULT_X_AXIS_COLOR_INACTIVE = new Color(0xffdae0);
export const DEFAULT_Y_AXIS_COLOR_ACTIVE = new Color(0x6cffcc);
export const DEFAULT_Y_AXIS_COLOR_INACTIVE = new Color(0xdaffee);
export const DEFAULT_Z_AXIS_COLOR_ACTIVE = new Color(0x6cd8ff);
export const DEFAULT_Z_AXIS_COLOR_INACTIVE = new Color(0xdaf2ff);
export const DEFAULT_XYZ_AXIS_COLOR_ACTIVE = new Color(0xffd86c);
export const DEFAULT_XYZ_AXIS_COLOR_INACTIVE = new Color(0xfff2da);
export const DEFAULT_XY_AXIS_COLOR_ACTIVE = new Color(0xffff00);
export const DEFAULT_XY_AXIS_COLOR_INACTIVE = new Color(0xffffde);
export const DEFAULT_YZ_AXIS_COLOR_ACTIVE = new Color(0x00ffff);
export const DEFAULT_YZ_AXIS_COLOR_INACTIVE = new Color(0xdeffff);
export const DEFAULT_XZ_AXIS_COLOR_ACTIVE = new Color(0xff00ff);
export const DEFAULT_XZ_AXIS_COLOR_INACTIVE = new Color(0xffdeff);
export const DEFAULT_XYZX_AXIS_COLOR_ACTIVE = new Color(0xffffff);
export const DEFAULT_XYZX_AXIS_COLOR_INACTIVE = new Color(0xd5d5d5);
export const DEFAULT_XYZY_AXIS_COLOR_ACTIVE = new Color(0xffffff);
export const DEFAULT_XYZY_AXIS_COLOR_INACTIVE = new Color(0xd5d5d5);
export const DEFAULT_XYZZ_AXIS_COLOR_ACTIVE = new Color(0xffffff);
export const DEFAULT_XYZZ_AXIS_COLOR_INACTIVE = new Color(0xd5d5d5);
export const DEFAULT_E_AXIS_COLOR_ACTIVE = new Color(0xffd86c);
export const DEFAULT_E_AXIS_COLOR_INACTIVE = new Color(0xfff2da);
export const DEFAULT_XYZE_AXIS_COLOR_ACTIVE = new Color(0xb6b6b6);
export const DEFAULT_XYZE_AXIS_COLOR_INACTIVE = new Color(0x686868);
export const DEFAULT_TRANSLATE_LINE_THICKNESS = 5.0;
export const DEFAULT_SCALE_LINE_THICKNESS = 5.0;
export const DEFAULT_ROTATE_LINE_THICKNESS = 5.0;
export const DEFAULT_OVERALL_LINE_THICKNESS = 5.0;
export const DEFAULT_INITIAL_ENTITY_ROTATION = [0, 0, 0];

export type TransformControlsGizmoPrivateGizmos = {
  ["translate"]: Object3D;
  ["scale"]: Object3D;
  ["rotate"]: Object3D;
  ["visible"]: boolean;
};

export enum Axis { 'X' = 'X' , 'Y' = 'Y' , 'Z' = 'Z' , 'XYZ' = 'XYZ' , 'XY' = 'XY' , 'XZ' = 'XZ' , 'YZ' = 'YZ', 'XYZY' = 'XYZY' , 'XYZX' = 'XYZX' , 'XYZZ' = 'XYZZ' , 'XYZE' = 'XYZE' , 'E' = 'E' }
export enum Mode { 'translate' = 'translate' , 'scale' = 'scale' , 'rotate' = 'rotate'}

export type AxisColorDictionary = {
  [axis in Axis]?: {
    active: number | string | Color;
    inactive: number | string | Color;
}}

export interface GizmoModeProps {
  axisToShow?: Axis[];  // Which axis to show
  lineThickness?: number; // Line thickness just for this gizmo
  axisColors?: AxisColorDictionary; // e.g. axisColors.X.active = 0xff0000, axisColors.X.inactive = 0xbb0000
}

export interface GizmoProps {
  lineThickness?: number; // Single setting for all axis line widths within the gizmo - rotate, translate, scale ( not the helper lines )
  gizmoTranslateProps?: GizmoModeProps;
  gizmoScaleProps?: GizmoModeProps;
  gizmoRotateProps?: GizmoModeProps;
  initialEntityRotation?: IVector3;
  locked?: boolean;
}

export const CircleGeometry = (radius: number, arc: number): LineGeometry => {
  const geometry = new LineGeometry();
  const vertices = [];

  for (let i = 0; i <= 64 * arc; ++i) {
    vertices.push(
      0,
      Math.cos((i / 32) * Math.PI) * radius,
      Math.sin((i / 32) * Math.PI) * radius
    );
  }

  geometry.setPositions(vertices);
  return geometry;
};
